// this is an autogenerated file from DesignSystem/TasksCreateForm/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksCreateForm_Board($location_id: uuid!) {
  tasks_boards(
    where: {
      status: { _eq: active }
      metadata: { _contains: { locations: [$location_id] } }
    }
    order_by: { name: asc }
  ) {
    id
    text: name
  }
}

`